export const HOME_TITLE: string = "Breaktooth"